import { type SectionType } from '../../sections/SectionTypeContext.tsx';

/**
 * Sezioni in cui si applicano i default del Popover "Creazione nuovi
 * Elementi" (obbligatorietà ed etichetta a blocco): solo il builder delle
 * sezioni frontoffice e backoffice, escluse le sezioni documento.
 * Condiviso da Popover e logiche dei default, così il perimetro resta unico.
 */
export function hasWidgetCreationDefaults(sectionType: SectionType): boolean {
  return sectionType === 'FRONTOFFICE' || sectionType === 'BACKOFFICE';
}
